// assets/product-grid-with-banner.js
// Simplified: Auto-plays HTML5 and iframe videos without thumbnails or play buttons

document.addEventListener('DOMContentLoaded', function () {
  console.log("🎬 Initializing autoplay for all video wrappers...");

  // Handle HTML5 video files
  const fileWrappers = document.querySelectorAll('.video-wrapper[data-video-type="file"]');
  console.log(`Found ${fileWrappers.length} video file wrapper(s)`);

  fileWrappers.forEach((wrapper, idx) => {
    const video = wrapper.querySelector('video');
    if (!video) {
      console.warn(`⚠️ No <video> tag found in file wrapper #${idx}`);
      return;
    }

    // Setup video playback
    video.muted = true;        // Autoplay requires mute
    video.autoplay = true;
    video.controls = true;     // Show controls (timeline, fullscreen, etc.)
    video.playsInline = true;  // Prevent fullscreen on mobile
    video.preload = 'auto';
    video.style.pointerEvents = 'auto';
    video.style.zIndex = 2;

    // Try to autoplay
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => console.log(`✅ HTML5 video #${idx} autoplayed successfully`))
        .catch(err => console.warn(`⚠️ Autoplay blocked for HTML5 video #${idx}:`, err));
    }

    // Optional: loop video
    // video.loop = true;

    // On end, log event
    video.addEventListener('ended', () => {
      console.log(`⏹️ HTML5 video #${idx} ended`);
    });
  });

  // Handle iframe embeds (YouTube / Vimeo)
  const iframeWrappers = document.querySelectorAll('.video-wrapper[data-video-type="iframe"]');
  console.log(`Found ${iframeWrappers.length} iframe wrapper(s)`);

  iframeWrappers.forEach((wrapper, idx) => {
    const iframe = wrapper.querySelector('iframe');
    if (!iframe) {
      console.warn(`⚠️ No <iframe> found in iframe wrapper #${idx}`);
      return;
    }

    let src = iframe.dataset.videoUrl || iframe.dataset.src || iframe.src;
    if (!src) {
      console.warn(`⚠️ No video URL found for iframe #${idx}`);
      return;
    }

    // Ensure autoplay params are included
    if (src.includes("youtube.com")) {
      src = src.replace("watch?v=", "embed/");
      src += (src.includes("?") ? "&" : "?") + "autoplay=1&mute=1&controls=1&playsinline=1";
    } else if (src.includes("vimeo.com")) {
      src += (src.includes("?") ? "&" : "?") + "autoplay=1&muted=1&controls=1&playsinline=1";
    }

    iframe.src = src;
    iframe.allow = "autoplay; fullscreen; picture-in-picture";
    iframe.style.pointerEvents = 'auto';
    iframe.style.zIndex = 2;

    console.log(`✅ Iframe #${idx} autoplay initialized → ${src}`);
  });
});
